import { Injectable } from '@angular/core';
import { VideoPreference } from '../utilities/constants';

@Injectable()
export class UtilityService {

  get prefersStandardDefVideo(): boolean {
    let p = localStorage.getItem(VideoPreference.QUALITY);
    return p == "true";
  }
  set prefersStandardDefVideo(value: boolean) {
    let p = value == true ? "true" : "false";
    localStorage.setItem(VideoPreference.QUALITY, p);
  }

  get languagePreference(): string {
    let p = localStorage.getItem(VideoPreference.LANGUAGE);
    return p ? p : "en-us";
  }
  set languagePreference(value: string) {
    //should get 'en-us' or 'es'
    localStorage.setItem(VideoPreference.LANGUAGE, value);
  }

    serialize(obj) {
        var str = [];
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
            }
        }
        return str.join('&');
    }

    detectMicrosoft(): boolean {
        let ua = window.navigator.userAgent;
        return ((ua.indexOf('MSIE') > -1) || ((ua.indexOf('Edge') > -1) || (ua.indexOf('Trident') > -1)))
    }
}
